import { createStore } from 'vuex';

import query from '@/store/query/moduleQuery';
import search from '@/store/search/moduleSearch';
import classification from '@/store/classification/moduleClassification';
import dashboard from '@/store/dashboard/moduleDashboard';
import graph from '@/store/graph/moduleGraph';
import getters from './getters';

export const store = createStore({
  getters,
  strict: false, // import.meta.env.NODE_ENV !== 'production', // https://vuex.vuejs.org/guide/strict.html
  modules: {
    search,
    query,
    graph,
    classification,
    dashboard,
  },
});
